import React, { useState, useEffect } from 'react';
import { abTestingAPI } from '../services/api';
import { TestTube, Plus, Play, Square, BarChart3 } from 'lucide-react';
import './ABTestingPage.css';

function ABTestingPage() {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTests();
  }, []);

  const loadTests = async () => {
    try {
      const response = await abTestingAPI.getAllTests();
      setTests(response.data.tests || []);
    } catch (error) {
      console.error('Error loading A/B tests:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ab-testing-page">
      <div className="page-header">
        <h1 className="page-title">
          <TestTube className="title-icon" />
          A/B Testing
        </h1>
        <button className="btn btn-primary">
          <Plus className="btn-icon" />
          Create Test
        </button>
      </div>

      <div className="tests-grid">
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading tests...</p>
          </div>
        ) : tests.length === 0 ? (
          <div className="empty-state">
            <TestTube className="empty-icon" />
            <h3>No A/B tests yet</h3>
            <p>Create your first test to optimize conversion rates</p>
            <button className="btn btn-primary">
              <Plus className="btn-icon" />
              Create Test
            </button>
          </div>
        ) : (
          tests.map((test) => (
            <div key={test.id} className="test-card">
              <h3>{test.name}</h3>
              <p>{test.description}</p>
              <div className="test-status">{test.status}</div>
              <div className="test-actions">
                <button className="btn-icon-btn">
                  <BarChart3 className="icon" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ABTestingPage;